import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import API from "../api/Createapi";
import Headers from "../components/Header";
import Resetpasswordpage from "../components/resetpassword/Resetpasswordpage";
function ResetPassword() {
    return (
        <>
            <Resetpasswordpage />
        </>
    )
}

export default ResetPassword;
